import { apiClient, optionalAuthApiClient } from '@/shared/lib/api-client';
import type {
  ReaderBootstrapResponse,
  BatchProgressEventsDto,
  ProgressIngestResponse,
} from '@bookclub/shared';

export async function fetchReaderBootstrap(
  clubId: string,
  chapterId: string,
): Promise<ReaderBootstrapResponse> {
  return optionalAuthApiClient
    .get('reader/bootstrap', { searchParams: { clubId, chapterId } })
    .json<ReaderBootstrapResponse>();
}

export async function sendProgressEvents(
  dto: BatchProgressEventsDto,
): Promise<ProgressIngestResponse> {
  return apiClient.post('progress/events', { json: dto }).json<ProgressIngestResponse>();
}
